import { render, staticRenderFns } from "./OrgItems.vue?vue&type=template&id=1357ef82&scoped=true&"
import script from "./OrgItems.vue?vue&type=script&lang=js&"
export * from "./OrgItems.vue?vue&type=script&lang=js&"
import style0 from "./OrgItems.vue?vue&type=style&index=0&id=1357ef82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1357ef82",
  null
  
)

export default component.exports